export default {
  CLEAR_STORE: 'COPYSTYLES/CLEAR_STORE',
  CLEAR_SELECTION: 'COPYSTYLES/CLEAR_SELECTION',
  ADD_ITEM: 'COPYSTYLES/ADD_ITEM',
  REMOVE_ITEM: 'COPYSTYLES/REMOVE_ITEM',
  SET_SOURCE: 'COPYSTYLES/SET_SOURCE',
  VALIDATION: 'COPYSTYLES/VALIDATION',
  CLEAR_VALIDATION: 'COPYSTYLES/CLEAR_VALIDATION',
};
